module.exports = __webpack_public_path__ + "static/media/menu-arrow_icon.2bb77693.svg";